import React from 'react';
import css from './concessionaria.css'

export default function Concessionaria({ concessionariaData }) {

    const {nome, logradouro, municipio, uf} = concessionariaData;

    return (
        <div style={{'padding':'10px'}}>
            <span className={css.titulo}><strong>{nome}</strong></span><br/>
            <span className={css.subtitulo}>{logradouro}, {municipio} - {uf}</span>

        </div>
    )
}